export const decodeTokenPayload = (token: string): any => {
  try {
    return JSON.parse(atob(token.split('.')[1]));
  } catch {
    return {};
  }
};

export interface OfflineUser {
  id: string;
  firstName: string;
  lastName: string;
  roles: { role: { name: string } }[];
}

// TODO: derive role from JWT payload once the backend encodes it in the token.
export const buildOfflineUser = (userId: string, firstName: string, lastName: string): OfflineUser => ({
  id: userId,
  firstName,
  lastName,
  roles: [{ role: { name: 'Service Provider' } }],
});
